import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import { callApi, formatDateTime } from '../../utils';
import { showError } from '../../actions/notificationActions';

import SearchForm from '.././SearchForm';
import DataTable, { PageHeader } from '../DataTable';

class List extends Component {
  state = {
    rows: [],
    query: '',
    page: 1,
    limit: 30,
    loading: false,
    pages: 1,
  };

  componentWillMount() {
    this.load();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  load = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, page } = this.state;

    this.startLoad();

    callApi(`/facility-verifications?q=${query}&page=${page}`)
      .then(({ data = [], meta = {} }) => {
        this.setState({ loading: false, rows: data, pages: meta.pages });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.load();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  view = (id) => {
    window.open(`/facility-verifications/${id}`);
  };

  render() {
    const { query, rows, page, loading, limit, pages } = this.state;

    const hasResults = rows.length > 0;
    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="Facility Verifications"
              subtitle={<>Verifications - Page {page}</>}
            >
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.load}
                loading={loading}
              />
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              page={page}
              total={pages}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Meter No</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Asset Provider</th>
                  <th>Service Provider</th>
                  <th>Status</th>
                  <th>Date</th>
                  {/* <th>Email</th> */}
                </tr>
              </thead>

              <tbody>
                {rows.map((t, i) => (
                  <tr onClick={() => this.view(t.id)} key={t.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{t.facility.reference}</td>
                    <td>{t.customer.name}</td>
                    <td>{t.customer.phone}</td>
                    <td>{t.facility.asset_provider}</td>
                    <td>{t.facility.service_provider}</td>
                    <td>{t.status}</td>
                    <td>{formatDateTime(t.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(List);
